/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemSlaContractDto } from './OemSlaContractDto';
import {
    OemSlaContractDtoFromJSON,
    OemSlaContractDtoFromJSONTyped,
    OemSlaContractDtoToJSON,
    OemSlaContractDtoToJSONTyped,
} from './OemSlaContractDto';

/**
 * 
 * @export
 * @interface CreateOemPartnerResponseDto
 */
export interface CreateOemPartnerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerResponseDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerResponseDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOemPartnerResponseDto
     */
    partnerName: string;
    /**
     * 
     * @type {OemSlaContractDto}
     * @memberof CreateOemPartnerResponseDto
     */
    slaContract?: OemSlaContractDto | null;
}

/**
 * Check if a given object implements the CreateOemPartnerResponseDto interface.
 */
export function instanceOfCreateOemPartnerResponseDto(value: object): value is CreateOemPartnerResponseDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    return true;
}

export function CreateOemPartnerResponseDtoFromJSON(json: any): CreateOemPartnerResponseDto {
    return CreateOemPartnerResponseDtoFromJSONTyped(json, false);
}

export function CreateOemPartnerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOemPartnerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'partnerOrgId': json['partnerOrgId'],
        'partnerName': json['partnerName'],
        'slaContract': json['slaContract'] == null ? undefined : OemSlaContractDtoFromJSON(json['slaContract']),
    };
}

export function CreateOemPartnerResponseDtoToJSON(json: any): CreateOemPartnerResponseDto {
    return CreateOemPartnerResponseDtoToJSONTyped(json, false);
}

export function CreateOemPartnerResponseDtoToJSONTyped(value?: CreateOemPartnerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'slaContract': OemSlaContractDtoToJSON(value['slaContract']),
    };
}

